import { connect } from 'react-redux';

import { selectors, actions } from '@amplement/backend-connector';
import BasicRooms from './index';

const mapStateToProps = state => ({
    _rooms: selectors.rooms.getRoomIdsSortByConnectedMemberSelector(state),
    rooms: selectors.rooms.getRooms(state),
    isLoading: !selectors.rooms.getRoomsLoaded(state)
});
const mapDispatchToProps = dispatch => ({
    getRooms: () => dispatch(actions.rooms.requestGetRooms())
});

export default connect(mapStateToProps, mapDispatchToProps)(BasicRooms);
